import { render, staticRenderFns } from "./SaibaMaisMapa.vue?vue&type=template&id=f56f7d60&"
import script from "./SaibaMaisMapa.vue?vue&type=script&lang=js&"
export * from "./SaibaMaisMapa.vue?vue&type=script&lang=js&"
import style0 from "./SaibaMaisMapa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports